import React from 'react';
import {render} from 'react-dom';
import TeamComponent from '../components/TeamComponent';
import ScrollAnimate from '../components/ScrollAnimate';
const data = [
  { pic:'./public/images/r5.jpg', title: 'CA. Dharmendra Kumar Chachan', text: 'He is a commerce graduate and fellow member of the Institute of Chartered Accountant of India (ICAI).'},
  { pic:'./public/images/c1.jpg', title: 'CA. Naresh Kumar Lath', text: 'He is a commerce graduate and fellow member of the Institute of Chartered Accountant of India (ICAI).'},
];
const OurTeams = (props) => {
  return(
    <section className="section-background-color">
      <h2 className="text-center">Our Team</h2>
      <ScrollAnimate offsetHeight={250} animateClass="home-team-animate">
        <article className="row align-spaced section__content">
          {data.map((item, index) =>
           <TeamComponent key={index} {...item} />
          )}
        </article>
      </ScrollAnimate>
    </section>
  );
};
export default OurTeams;



// WEBPACK FOOTER //
// ./src/HomePage/OurTeams.js